module.exports = __webpack_public_path__ + "img/snow_white.4194659c.svg";